module.exports = __webpack_public_path__ + "img/suorin.def3544b.png";